import { Slider, Stack, TextField, Typography } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';

const RecipientWeightSlider = ({
  value = 0,
  max = 100,
  onChange,
  disabled = false,
  color = '#298171',
  label,
  unit,
}) => {
  const { t } = useTranslation('translation');
  const numValue = parseFloat(value) || 0;
  const sliderMax = Math.max(max, numValue, 1);
  const clampAmount = (nextValue) => Math.max(0, parseFloat(nextValue) || 0);

  return (
    <Stack
      direction={{ xs: 'column', sm: 'row' }}
      alignItems={{ xs: 'stretch', sm: 'center' }}
      spacing={1.5}
      sx={{ width: '100%' }}
    >
      <Slider
        value={Math.min(numValue, sliderMax)}
        min={0}
        max={sliderMax}
        step={1}
        disabled={disabled}
        valueLabelDisplay="auto"
        onChange={(e, newVal) => onChange(clampAmount(newVal))}
        onClick={(e) => e.stopPropagation()}
        sx={{
          flex: 1,
          minWidth: 50,
          '& .MuiSlider-track': {
            backgroundColor: color,
            borderColor: color,
          },
          '& .MuiSlider-thumb': {
            backgroundColor: color,
            width: 16,
            height: 16,
            '&:hover, &.Mui-focusVisible': {
              boxShadow: `0 0 0 8px ${color}22`,
            },
          },
          '& .MuiSlider-rail': {
            backgroundColor: 'grey.300',
          },
        }}
      />
      <TextField
        value={numValue}
        type="number"
        size="small"
        label={label || t('common.weight')}
        disabled={disabled}
        onClick={(e) => e.stopPropagation()}
        onChange={(e) => onChange(clampAmount(e.target.value))}
        onKeyDown={(e) => {
          if (e.key === '-') {
            e.preventDefault();
          }
        }}
        slotProps={{
          htmlInput: { min: 0 },
          input: {
            endAdornment: unit ? (
              <Typography
                variant="caption"
                color="text.secondary"
                sx={{ ml: 0.5, whiteSpace: 'nowrap' }}
              >
                {unit}
              </Typography>
            ) : undefined,
          },
        }}
        sx={{
          width: { xs: '100%', sm: '136px' },
          minWidth: { xs: 0, sm: '136px' },
          flexShrink: 0,
        }}
      />
    </Stack>
  );
};

export default RecipientWeightSlider;
